/**
 * Whether the Enhance tile of the One tool view is "Coming soon" (badge, disabled). The ai-visuals Enhance ships behind
 * `allow-autoenhance-photo-studio`; the Lab engine runs its own Enhance — the All tools view lists it whatever that flag
 * says — so with the Lab engine on, Enhance is never "Coming soon".
 */
export const isEnhanceComingSoon = ({ allowAutoenhance, isLabSdkEngine }: { allowAutoenhance: boolean, isLabSdkEngine: boolean }): boolean =>
  !allowAutoenhance && !isLabSdkEngine
